import {Button, getPrimitive} from '@tickchak/react-share/app';
import ValidityIcon from '../../../../assets/icons/ValidityIcon';
import {useTranslation} from 'react-i18next';

function ValidityButton({ticket, onClick}) {
    const hasValidity = (ticket) => ticket.validity?.startDateActive === 1 || ticket.validity?.endDateActive === 1;
    const {t} = useTranslation('ticket');

    if(!hasValidity(ticket)) {
        return null;
    }

    return (
        <Button
            iconStart={<ValidityIcon />}
            size="chip"
            customStyle={{backgroundColor: getPrimitive('greens.green200')}}
            onClick={onClick}
            aria-label={t('ticketValidity')}
        />
    );
}

export default ValidityButton;
